import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';

const OVERLAY_ALPHA_MAX = 0.35;

/**
 *
 */
EDC.Games.CategorizationSimpleFrame.CategoryItem = function (scene, categoryText, categoryId) {
  this.scene = scene;
  this.categoryText = categoryText;
  this.categoryId = categoryId;
  this.container = null;
  this.categoryScale = 1;
  this.answerMark = null;
  this.isDisabled = false;
  this.overlayTween = null;
  this.cursorManager = scene.cursorManager;
  return this;
};
/**
 *
 */
// eslint-disable-next-line max-len
EDC.Games.CategorizationSimpleFrame.CategoryItem.prototype.create = function (slotX, slotWidth, y, scale = 1) {
  this.container = this.scene.add.container(0, 0);
  const frame = this.scene.add.sprite(0, 0, 'category-frame');
  this.container.add(frame);

  const overlay = this.scene.add.sprite(0, 0, 'category-frame-hover');
  overlay.setAlpha(0);
  this.container.add(overlay);

  const icon = this.scene.add.sprite(0, 50, `category-${this.categoryId}`);
  this.container.add(icon);

  const font = {
    font: `${this.scene.gameConfig.categorySize} ${this.scene.gameConfig.font}`,
  };

  const text = this.scene.add.text(0, -120, this.categoryText, font).setOrigin(0.5, 0.5);
  this.container.add(text);

  let bounds = this.container.getBounds();
  this.container.x += bounds.width / 2;
  this.container.y += 700;

  bounds = this.container.getBounds();
  this.container.x += slotX + (slotWidth - bounds.width) / 2;

  this.container.setSize(bounds.width, bounds.height);
  this.container.setInteractive();
  this.container.on('pointerover', this.pointerOver, this);
  this.container.on('pointerout', this.pointerOut, this);
  this.container.on('pointerup', this.pointerUp, this);

  this.cursorManager.setDefaultDraggableEvents(this.container);

  this.answerMark = new AnswerMark(this.scene, this.container).setScale(0.5);

  this.categoryScale = scale;
  this.container.setScale(this.categoryScale);

  return this;
};
/**
 *
 */
EDC.Games.CategorizationSimpleFrame.CategoryItem.prototype.pointerOver = function () {
  if (this.isDisabled) return;
  const overlay = this.container.getAt(1);
  this.overlayTween = this.scene.tweens.add({
    targets: overlay,
    alpha: OVERLAY_ALPHA_MAX,
    duration: 250,
    ease: 'Linear',
  });
  this.scene.tweens.add({
    targets: this.container,
    scaleX: this.container.scaleX + (this.categoryScale * 10) / 100,
    scaleY: this.container.scaleY + (this.categoryScale * 10) / 100,
    duration: 250,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.CategorizationSimpleFrame.CategoryItem.prototype.pointerOut = function () {
  if (this.isDisabled) return;
  const overlay = this.container.getAt(1);
  if (this.overlayTween && this.overlayTween.isPlaying()) {
    this.overlayTween.stop();
  }
  this.overlayTween = this.scene.tweens.add({
    targets: overlay,
    alpha: 0,
    duration: 250,
    ease: 'Linear',
  });
  this.scene.tweens.add({
    targets: this.container,
    scaleX: this.categoryScale,
    scaleY: this.categoryScale,
    duration: 250,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.CategorizationSimpleFrame.CategoryItem.prototype.pointerUp = function () {
  if (this.isDisabled) return;
  this.isDisabled = true;
  const currentCategory = this.scene.getCurrentIterationCategory();
  if (this.categoryId === currentCategory) {
    this.scene.correctAnswer();
    const items = this.scene.getCategoryItems();
    for (let i = 0; i < items.length; i++) {
      items[i].disableInteractive();
    }
    this.answerMark.showMark(
      true,
      () => {
        this.scene.nextIteration();
      },
    );
  } else {
    this.scene.wrongAnswer();
    this.answerMark.showMark(false, () => {});
    this.disable();
  }
};
/**
 *
 */
EDC.Games.CategorizationSimpleFrame.CategoryItem.prototype.disable = function () {
  this.isDisabled = true;
  if (this.overlayTween && this.overlayTween.isPlaying()) {
    this.overlayTween.stop();
  }
  this.container.getAt(1).setAlpha(0);
  this.scene.tweens.add({
    targets: this.container,
    scaleX: this.categoryScale,
    scaleY: this.categoryScale,
    duration: 250,
    ease: 'Linear',
  });
  this.container.getAt(0).setTint(0xff0000);
  this.container.getAt(2).setTint(0xff0000);
};

EDC.Games.CategorizationSimpleFrame.CategoryItem.prototype.disableInteractive = function () {
  this.isDisabled = true;
};
/**
 *
 */
EDC.Games.CategorizationSimpleFrame.CategoryItem.prototype.enable = function () {
  this.isDisabled = false;
  this.container.getAt(0).setTint(0xffffff);
  this.container.getAt(2).setTint(0xffffff);
  this.answerMark.reset();
};

EDC.Games.CategorizationSimpleFrame.CategoryItem.prototype.deleteObject = function () {
  this.container.destroy();
};

export default EDC.Games.CategorizationSimpleFrame.CategoryItem;
